import React from 'react';
import { FiDownload, FiLock } from 'react-icons/fi';

const UnknownSourcesToggle = ({ 
  isUnknownSourcesEnabled, 
  onToggle, 
  disabled = false, 
  deviceId,
  className = "" 
}) => {
  const handleToggle = () => {
    if (!disabled) {
      onToggle(deviceId, isUnknownSourcesEnabled ? 'disable_unknown_sources' : 'enable_unknown_sources');
    }
  };

  return (
    <button
      onClick={handleToggle}
      disabled={disabled}
      className={`
        relative inline-flex h-7 w-14 items-center rounded-full transition-all duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 shadow-sm
        ${isUnknownSourcesEnabled 
          ? 'bg-orange-600 hover:bg-orange-700 shadow-orange-200' 
          : 'bg-gray-200 hover:bg-gray-300 shadow-gray-200'
        }
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
        ${className}
      `}
      title={isUnknownSourcesEnabled ? 'Deshabilitar orígenes desconocidos' : 'Habilitar orígenes desconocidos'}
    >
      {/* Círculo del switch */}
      <span
        className={`
          inline-block h-5 w-5 transform rounded-full bg-white shadow-md transition-all duration-300 ease-in-out
          ${isUnknownSourcesEnabled ? 'translate-x-8' : 'translate-x-1'}
        `}
      />

      {/* Icono del estado (dentro del círculo) */}
      <div className={`
        absolute left-1.5 flex items-center justify-center transition-all duration-300 ease-in-out
        ${isUnknownSourcesEnabled ? 'opacity-0 scale-0' : 'opacity-100 scale-100'}
      `}>
        <FiLock size={10} className="text-gray-500" />
      </div>

      <div className={`
        absolute right-1.5 flex items-center justify-center transition-all duration-300 ease-in-out
        ${isUnknownSourcesEnabled ? 'opacity-100 scale-100' : 'opacity-0 scale-0'}
      `}>
        <FiDownload size={10} className="text-white" />
      </div>
    </button>
  );
};

export default UnknownSourcesToggle;
